<template>

    <div class="item pointer cf" @click="openPage">

        <v-image class="item-img fl" :src="data.cover_id || data.picture" />

        <div class="item-content fl overflow relative">

            <div class="item-title">
                <span v-if="type === 1">#</span>
                {{ data.name || data.title }}
                <span v-if="type === 1">#</span>
            </div>

            <div class="item-subtitle line1" >{{ data.intro }}</div>

            <div v-if="type === 0" class="item-position item-news absolute">
                <span>文/{{ data.author }}</span>
                <span>{{ data.time }}</span>
            </div>

            <div v-else-if="type === 1" class="item-position absolute cf">

                <div class="item-tag fl">{{ data.type == 1 ? '热议' : data.type == 2 ? '投票' : '观点PK' }}</div>

            </div>

            <div v-else class="item-position item-news absolute">

                <span>活动内容：{{ data.type === 2 ? '福利' : '应援' }}</span>

                <span>人数：{{ data.join_count }}</span>

                <span>时间：{{ data.time_start }}-{{ data.time_end }}</span>

            </div>

        </div>

    </div>

</template>

<script>
import mixin from "./mixin/mixin";
import vImage from '@/components/image';
import props from "@/layout/layout-list-item/props";
export default {
    name: "layout-list-item",
    mixins: [mixin],
    components: {
        vImage
    },
    props
}
</script>

<style scoped src="./style.css"></style>
